<template>
  <div
    :class="{'aside-is-collapsed': collapse}"
    class="flex flex-col h-full">
    <header-core />
    <main class="flex h-full overflow-hidden relative">
      <aside-core :isOpen="aside" @toggle="asideBehaviour" @toogleAside="toogleAside"/>
      <router-view class="main-content" />
      <div class="absolute left-0 bottom-0 z-20 lg:hidden">
        <div class="pl-4 py-2 md:py-1">
          <base-button-icon
            @click="toogleAside"
            name="hamburguer" mode="primary-phantom" size="xl" />
        </div>
      </div>
      <transition name="fade">
        <div class="fixed right-6 bottom-12 z-chatbot" v-if="showButtonChatbot">
          <div class="pl-4 py-2 md:py-1">
            <button 
              type="button"
              id="buttonchatbot"
              class="cursor-pointer rounded-full bg-white shadow-xl/30 shadow-secondary border-2 border-secondary-400 dark:border-secondary-500 dark:bg-darkblue-600"
              :style="darkMode ? 'box-shadow: var(--secondary-900) 3px 3px 10px 0px;' : 'box-shadow: var(--secondary-400) 3px 3px 10px 0px;'"
              @click="toggleChatbot"
            >
              <base-logo
                filename="chatbot.svg"
                class="brand p-2 max-w-xs max-h-20"
                alt="Chatbot"
                title="Aída"
              />
            </button>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="fixed right-4 bottom-[6.5rem] z-chatbot-close" v-if="showButtonChatbot">
          <div class="pl-4 py-2 md:py-1">
            <base-button-icon
                @click="setshowButtonChatbot(false)"
                name="cross"
                mode="secondary"
                size="xs"
                iconSize="xsm"
              />
          </div>
        </div>
      </transition>
    </main>
    <chat-panel
      :panelOpen="showModalChatbot"
      @togglePanel="toggleChatbot"
    />
  </div>
</template>
<script>
import HeaderCore from '@/components/HeaderCore.vue'
import AsideCore from '@/components/AsideCore.vue'
import ChatPanel from '@/components/ia/ChatPanel.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'private-home',
  components: {
    HeaderCore,
    AsideCore,
    ChatPanel
  },
  data: function () {
    return {
      aside: false,
      collapse: false,
      // Chat bot
      showModalChatbot: false,
    }
  },
  mounted: function () {
    if (document.body.classList.contains('static-css')) {
      document.body.classList.remove('static-css')
    }
    setTimeout(() => {
      if (process.env.VUE_APP_AIAPI && process.env.VUE_APP_AIAPI !== 'off') { 
        this.setshowButtonChatbot(true)
      }
    }, 1000)
  },
  computed: {
    ...mapGetters('app', ['showButtonChatbot', 'darkMode'])
  },
  methods: {
    ...mapMutations('app', ['setshowButtonChatbot']),
    toggleChatbot: function () {
      this.showModalChatbot = !this.showModalChatbot
      this.setshowButtonChatbot(!this.showButtonChatbot)
    },
    toogleAside: function () {
      this.aside = !this.aside
    },
    asideBehaviour: function (res) {
      this.aside = res.aside
      this.collapse = res.collapse
      // this.collapsed = response.collapse
    }
  }
}
</script>
<style lang="scss" scoped>
#buttonchatbot {
  &:active {
    transform: scale(0.9);
  }
}

@include breakpoint(lg) {
  .main-content {
    max-width: calc(100% - 18.125rem);
  }
  .aside-is-collapsed .main-content {
    max-width: calc(100% - 4.5rem);
  }
}
</style>
